/**
 * @return {String}
 */
export default function contactUsUrl() {
  return `http://sunbit.com/c_contact.html`;
}



// WEBPACK FOOTER //
// ./src/utils/url/contactUsUrl.js